const items: FAQInterface[] = [
  {
    title: 'ฉันจะได้ไฟล์เอกสารในนามสกุลอะไรบ้าง',
    content:
      'คุณจะได้รับเอกสารทั้งหมดในรูปแบบการบีบอัดไฟล์ (.Zip) โดยคุณสามารถแตกไฟล์ได้ด้วยโปรแกรมแตกไฟล์ เช่น WinZip, 7-Zip เป็นต้น เอกสารทั้งหมดนั้นถูกสร้างโดย Microsoft Office เวอร์ชัน 2010 ดังนั้นคุณจะสามารถเปิดเอกสารโดยใช้ Microsoft Office เวอร์ชัน 2010 ขึ้นไป เอกสารส่วนใหญ่จะอยู่ในรูปแบบไฟล์ Word document (นามสกุล .doc หรือ .docx) แต่จะมีทั้งในรูปแบบ Excel spreadsheets และ PowerPoint',
  },
  {
    title: 'ฉันเปลี่ยนอะไรได้บ้างในเอกสารที่ได้รับ',
    content:
      'ได้ทุกอย่างเลย! ชุดเอกสารของเราออกแบบมาเพื่อให้คุณสามารถปรับแต่งให้เป็นของคุณเอง คุณสามารถจัดรูปแบบ เพิ่มหรือลดเนื้อหา หรือคัดลอกเนื้อหาไปใช้ในเอกสารของคุณเองได้ตามต้องการ',
  },
  {
    title: 'PDPA Prokit ช่วยฉันได้อย่างไร',
    content:
      'ช่วยประหยัดเวลาและค่าใช้จ่ายคุณได้มาก เพราะเป็นการรวบรวมเอกสารเพื่อให้คุณปฏิบัติตามกรอบ PDPA  รวมถึงกฎระเบียบต่าง ๆ ฯลฯ ที่เกี่ยวข้อง ในรูปแบบเนื้อหาที่เหมาะสมกับองค์กรส่วนใหญ่',
  },
  {
    title:
      'หากฉันมีปัญหาเกี่ยวกับเอกสารที่ได้รับหรือมีข้อสงสัยเกี่ยวกับการนำไปใช้งานต้องทำอย่างไร',
    content:
      'ไม่ต้องห่วง เรามีบริการให้ความช่วยเหลือเกี่ยวกับเอกสารที่คุณได้รับผ่านทางอีเมลตั้งแต่วันแรกที่คุณซื้อ โดยทีมงานและผู้เชี่ยวชาญทางด้านกฎหมายของเราจะช่วยตอบข้อสงสัยต่าง ๆ ของคุณผ่านอีเมลฟรีเป็นเวลา 1 เดือน',
  },
  {
    title: 'PDPA Prokit ขายเอกสารแยกชุดหรือไม่',
    content:
      'ไม่ เราสร้างชุดเอกสารนี้ด้วยความตั้งใจที่จะให้เป็นโซลูชั่นสำเร็จรูปที่ทำให้องค์กรของคุณปฏิบัติตามกรอบกฎหมาย PDPA ได้อย่างรวดเร็วและมีประสิทธิผลที่สุด',
  },
  {
    title:
      'หากซื้อชุดเอกสารแล้วจะมีทีมนักกฎหมายมาช่วยจัดทำ PDPA หรือสอนการใช้งานให้หรือไม่',
    content:
      'เนื่องจากชุดเอกสารนี้เป็นเอกสารที่จัดทำขึ้นเพื่อให้องค์กรของคุณสามารถปฏิบัติตาม PDPA ได้ด้วยตนเอง การจัดทำ PDPA หรือการสอนการใช้งานโดยทีมนักกฏหมายจึงไม่อยู่ในขอบเขตของการให้บริการ อย่างไรก็ตามคุณไม่ต้องกังวลไป เพราะเมื่อซื้อชุดเอกสารแล้วคุณจะสามารถรับชมคลิปวิดิโอแนะนำการใช้งานเอกสารเบื้องต้น ผ่านแพลตฟอร์มได้ทันที รวมถึงได้รับบริการปรึกษานักกฎหมายผ่านอีเมลได้ฟรี 1 เดือน',
  },
]

export default {
  items,
}
